import React, { useState } from "react";
import { Icon } from "../Icon";

export function MonthHeaderInput(props) {
  const { calendar, date, update, tooltipID } = props;
  const [showMonths, setShowMonths] = useState(false);
  // const [month, setMonth] = useState(null);
  const { months } = calendar;

  const handleMonthSelect = (month) => {
    // console.log('month', month);
    const monthID = months.findIndex(
      (m) => m.name === month.name && m.days === month.days
    );
    // console.log('Updating month to ', monthID);
    update({ month: monthID });
    setShowMonths(false);
  };

  const toggleMonthSelector = () => {
    setShowMonths(!showMonths);
  };

  const handleMonthPrev = (ev) => {
    ev.preventDefault();
    const monthID = parseInt(date.month, 10);
    const year = parseInt(date.yearSTD, 10);
    if (!Number.isNaN(monthID)) {
      if (monthID - 1 < 0) {
        update({
          month: months.length - 1,
          yearSTD: year - 1,
        });
      } else {
        update({ month: monthID - 1 });
      }
    }
  };

  const handleMonthNext = (ev) => {
    ev.preventDefault();
    const monthID = parseInt(date.month, 10);
    const year = parseInt(date.yearSTD, 10);
    if (!Number.isNaN(monthID)) {
      if (monthID + 1 >= months.length) {
        // console.log('Advancing month and year', year);
        update({
          month: 0,
          yearSTD: year + 1,
        });
      } else {
        update({ month: monthID + 1 });
      }
    }
  };

  const activeMonth = months[parseInt(date.month, 10)]; //TODO: Fix this!
  return (
    <div className="chronos-calendar-date-picker-month-header">
      {showMonths && (
        <div className="calendar-dropdown-month-selector">
          {months.map((month, i) => (
            <MonthOption
              month={month}
              key={i}
              active={i === parseInt(date.month, 10)}
              select={handleMonthSelect}
            />
          ))}
        </div>
      )}
      {!showMonths && (
        <React.Fragment>
          <span
            className="chronos-calendar-dropdown-nav-btn"
            onClick={handleMonthPrev}
          >
            <Icon icon="far fa-chevron-left" />
          </span>
          <div
            className="chronos-calendar-dropdown-month"
            onClick={toggleMonthSelector}
            data-for={tooltipID}
            data-tip="Click to edit"
          >
            {activeMonth.name}
          </div>
          <span
            className="chronos-calendar-dropdown-nav-btn"
            onClick={handleMonthNext}
          >
            <Icon icon="far fa-chevron-right" />
          </span>
        </React.Fragment>
      )}
    </div>
  );
}

function MonthOption({ month, select, active }) {
  const classes = ["calendar-month-selector-option"];
  if (active) classes.push("calendar-month-active");
  const handleClick = () => {
    if (select) select(month);
  };
  return (
    <div className={classes.join(" ")} onClick={handleClick}>
      {month.name}
    </div>
  );
}
